import { Link, useLocation } from 'react-router';
import { cn } from '@/lib/cn';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import {
    accessSubPaths,
    profileMenuItems,
} from '@/features/profile/model/profileMenuItems';
import { ProfilePaths } from '@/features/profile/model/types';

type ProfileDesktopMenuProps = {
    isAdolescent: boolean;
    hasVeterinarianCoverage: boolean;
};

export const ProfileDesktopMenu = ({
    isAdolescent,
    hasVeterinarianCoverage,
}: ProfileDesktopMenuProps) => {
    const { pathname } = useLocation();
    const currentPath =
        pathname.split('/').filter(Boolean).at(-1) ??
        ProfilePaths.MyInformation;
    const isAccessSubPage = accessSubPaths.some(
        (p) => p.toLowerCase() === currentPath.toLowerCase(),
    );
    const selectedMenuItem = isAccessSubPage
        ? ProfilePaths.Access
        : currentPath;

    const visibleMenuItems = profileMenuItems.filter(
        (item) =>
            !(item.path === ProfilePaths.Household && isAdolescent) &&
            !(item.path === ProfilePaths.Pets && !hasVeterinarianCoverage),
    );

    return (
        <nav
            aria-label={R.MyProfile}
            className="h-full border-r border-(--color-border-muted) py-4"
        >
            <ul>
                {visibleMenuItems.map((item) => {
                    const isSelected =
                        item.path.toLowerCase() ===
                        selectedMenuItem.toLowerCase();
                    const ariaCurrent = isSelected
                        ? isAccessSubPage
                            ? 'location'
                            : 'page'
                        : undefined;

                    return (
                        <li key={item.path}>
                            <Link
                                to={`/${item.path}`}
                                aria-current={ariaCurrent}
                                className={cn(
                                    'block border-l-4 p-6 leading-tight text-(--color-text-primary) hover:bg-(--color-bg-surface-hover) focus-visible:ring-2 focus-visible:ring-(--color-border-focus-primary) focus-visible:outline-none focus-visible:ring-inset',
                                    isSelected
                                        ? 'border-(--color-border-selected) font-bold'
                                        : 'border-transparent',
                                )}
                            >
                                {item.title}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
